import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Command } from 'cmdk';
import { useVisibleNav } from './nav';

/** Cmd/Ctrl-K jump menu. Navigation only for now; Wave B pages can add groups. */
export function CommandPalette({ open, onOpenChange }: { open: boolean; onOpenChange: (o: boolean) => void }) {
  const items = useVisibleNav();
  const navigate = useNavigate();
  useEffect(() => {
    const h = (e: KeyboardEvent) => {
      if (e.key.toLowerCase() === 'k' && (e.metaKey || e.ctrlKey)) {
        e.preventDefault();
        onOpenChange(!open);
      }
    };
    document.addEventListener('keydown', h);
    return () => document.removeEventListener('keydown', h);
  }, [open, onOpenChange]);

  return (
    <Command.Dialog
      open={open}
      onOpenChange={onOpenChange}
      label="Jump to"
      overlayClassName="fixed inset-0 z-40 bg-black/60"
      contentClassName="fixed left-1/2 top-[15vh] z-50 w-[calc(100vw-32px)] max-w-lg -translate-x-1/2 overflow-hidden rounded-lg border border-line bg-raised shadow-overlay"
    >
      <Command.Input
        placeholder="Jump to a page"
        aria-label="Jump to a page"
        className="h-10 w-full border-b border-line-subtle bg-transparent px-3 text-sm"
      />
      <Command.List className="max-h-72 overflow-auto p-1">
        <Command.Empty className="px-3 py-6 text-center text-sm text-fg-muted">No matching page.</Command.Empty>
        {items.map(({ to, label, icon: Icon }) => (
          <Command.Item
            key={to}
            value={label}
            onSelect={() => {
              onOpenChange(false);
              navigate(to);
            }}
            className="flex h-8 cursor-pointer items-center gap-2 rounded-sm px-2 text-sm text-fg-muted data-[selected=true]:bg-hover data-[selected=true]:text-fg"
          >
            <Icon className="size-4" aria-hidden />
            {label}
          </Command.Item>
        ))}
      </Command.List>
    </Command.Dialog>
  );
}
